import React from "react";
import { Button, Table, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function StaffDetails({ nextStep, prevStep }) {
  return (
    <>
      <div className="form-navigator-body">
        <Table bordered responsive>
          <thead className="text-center table-secondary">
            <tr>
              <th>Indicator</th>
              <th>Number</th>
              <th>No of LFUs</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                No. of pregnant women registered in the reporting month (from
                HMIS)
              </td>
              <td>
                <input
                  type="text"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td className="table-secondary">Not Applicable</td>
              <td>
                <input
                  type="text"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
            </tr>
            <tr>
              <td>Total no of Pregnant Women screened for HIV</td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td className="table-secondary">Not Applicable</td>
              <td>
                <input
                  type="text"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              
            </tr>
            <tr>
              <td>
                Out of total no of Pregnant Women screened no. found reactive
                for HIV
              </td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td className="table-secondary">Not Applicable</td>
              <td>
                <input
                  type="text"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
            </tr>
            <tr>
              <td>Total no of Pregnant Women confirmed HIV Positive</td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td>
                <input
                  type="text"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
            </tr>
            <tr>
              <td>
                Total no of newly detected HIV positive Pregnant Women linked to
                ART
              </td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td>
                <input
                  type="text"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
            </tr>
            <tr>
              <td>
                Total no of already known HIV positive Pregnant Women on ART
              </td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td className="table-secondary">Not Applicable</td>
              <td>
                <input
                  type="text"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
            </tr>
            <tr>
              <td>Total no of Pregnant Women screened for Syphilis</td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td className="table-secondary">Not Applicable</td>
              <td>
                <input
                  type="text"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
            </tr>
            <tr>
              <td>Total no of Pregnant Women found Syphilis Reactive</td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td className="table-secondary">Not Applicable</td>
              <td>
                <input
                  type="text"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
            </tr>
            <tr>
              <td>Total no of Syphilis Reactive Pregnant Women treated</td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td>
                <input
                  type="text"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
            </tr>
            <tr>
              <td>
                Total no of Viral load tests conducted for HIV positive Pregnant
                Women between 32 to 36 weeks
              </td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td>
                <input
                  type="text"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
            </tr>
            <tr>
              <td>
                Total no of HIV positive pregnant women on ART who are virally
                suppressed
              </td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td className="table-secondary">Not Applicable</td>
              <td>
                <input
                  type="text"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
            </tr>
          </tbody>
        </Table>

        <Table bordered>
          <thead>
            <tr className="table-secondary text-center align-middle">
              <th></th>
              <th></th>
              <th>Target (children due for testing)</th>
              <th>No. tested</th>
              <th>Found HIV Positive</th>
              <th>Left Outs</th>
              <th>Remarks</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td rowSpan={3}>
                Number of children tested as per EID (Early Infant Diagnosis)
                Cascade
              </td>
              <td>6 Weeks</td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td>
                <input
                  type="text"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
            </tr>
            <tr>
              <td>6 Months</td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td>
                <input
                  type="text"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
            </tr>
            <tr>
              <td>12 Months</td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td>
                <input
                  type="number"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
              <td>
                <input
                  type="text"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
            </tr>

            {/* Other Specify */}
            <tr>
              <td>Other (Specify)</td>
              <td colSpan={6}>
                <input
                  type="text"
                  className="text-center"
                  placeholder="Please Enter"
                />
              </td>
            </tr>
          </tbody>
        </Table>
      </div>

      <div className="form-navigate-footer">
        <button onClick={prevStep} className="btn btn-outline-secondary">
          Back
        </button>
        <button onClick={nextStep} className="btn btn-dark border-0">
          Next
        </button>
      </div>
    </>
  );
}
